<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="actions" slot-scope="{ item }">
                <b-row>
                    <b-col>
                        <b-btn
                            title="Agregar compromisos"
                            size="sm"
                            variant="primary"
                            @click="$emit('open-modal-commitments', item)"
                        >
                            <i
                                class="fa fa-pencil-square-o"
                                aria-hidden="true"
                            ></i>
                        </b-btn>
                        <b-btn
                            size="sm"
                            title="Descargar Resultados"
                            variant="primary"
                            @click="downloadQualificationReport(item)"
                        >
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
            <template
                slot="performance_evaluation.initial_qualification_period"
                slot-scope="{ item }"
                >{{
                    item.performance_evaluation.initial_qualification_period
                        | date
                }}</template
            >
            <template
                slot="performance_evaluation.final_qualification_period"
                slot-scope="{ item }"
                >{{
                    item.performance_evaluation.final_qualification_period
                        | date
                }}</template
            >
            <template
                slot="performance_evaluation.max_actions_plan_date"
                slot-scope="{ item }"
                >{{
                    item.performance_evaluation.max_actions_plan_date | date
                }}</template
            >
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [Array, Object],
            default: '',
        },
        onChangePage: {
            type: Function,
        },
    },
    data: () => ({
        fields,
    }),
    methods: {
        downloadQualificationReport(evaluationEmployee) {
            console.log(evaluationEmployee)
            window.open(
                'web/v1/performance-evaluations/qualification-report?' +
                    'evaluationId' +
                    '=' +
                    evaluationEmployee.performance_evaluation_id +
                    '&' +
                    'evaluatedId' +
                    '=' +
                    evaluationEmployee.evaluated_id,
                '_blank'
            )
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'performance_evaluation.name',
        label: 'Nombre',
    },
    {
        key: 'total_score',
        label: 'Puntaje',
    },
    {
        key: 'performance_range.name',
        label: 'Desempeño',
    },
    {
        key: 'evaluator.name',
        label: 'Evaluador',
    },
    {
        key: 'performance_evaluation.initial_qualification_period',
        label: 'Período inicial',
    },
    {
        key: 'performance_evaluation.final_qualification_period',
        label: 'Período final',
    },
    {
        key: 'performance_evaluation.max_actions_plan_date',
        label: 'Fecha maxima a presentar plan',
    },
    {
        key: 'aspects_to_improve',
        label: 'Aspectos a mejorar',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
